import { DvGridComponent, DvToolbarAction } from '@devinco/ui/grid';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { GridOptionsService } from '@features/vt-grid/grid-options/grid-options.service';
import { UserDevicesGridService } from './user-devices.grid.service';
import { DvTabBase } from '@devinco/ui/legacy';
import { DeviceDto } from '@shared/interfaces/device';
import { GridOptions } from 'ag-grid-community';
import { Entity } from '@shared/constants/entity';
import { FilterModelWithKeys } from '@features/vt-grid/interfaces/grid-context';
import { AgGridModule } from 'ag-grid-angular';
import { DirectivesModule } from '@shared/directives/directives.module';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { take } from 'rxjs';

@Component({
  selector: 'app-user-devices-tab',
  imports: [DvGridComponent, AgGridModule, DirectivesModule],
  templateUrl: './user-devices-tab.component.html',
  providers: [GridOptionsService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDevicesTabComponent extends DvTabBase implements OnInit {
  private gridOptionsService = inject(GridOptionsService);
  private gridService = inject(UserDevicesGridService);
  private rolesAndPermissionsService = inject(UserRolesAndPermissionsService);
  private cdRef = inject(ChangeDetectorRef);

  actions: DvToolbarAction<DeviceDto>[];
  gridOptions: GridOptions<DeviceDto> | undefined;

  ngOnInit(): void {
    this.rolesAndPermissionsService
      .hasPermissions([RolesAndPermissions.UserEdit])
      .pipe(take(1))
      .subscribe(hasUserEdit => {
        this.actions = this.gridService.getGridActions(hasUserEdit);
      });
  }

  onBaseActions(): void {}
  onEntityCreate(): void {}
  onEntityUpdate(): void {
    if (!this.entityId) return;

    if (!this.gridOptions) {
      this.setupGridOptions();
    } else {
      this.gridOptions.context.extraFilter = this.getFilterModel(this.entityId);
      this.gridOptions.context.loadClientSideData?.(
        this.gridOptions.context.extraFilter,
        true
      );
    }
  }

  private setupGridOptions(): void {
    this.gridOptions = this.gridOptionsService.clientSide(
      this.gridService.getColDefs(),
      Entity.Device,
      this.getFilterModel(this.entityId)
    );
    this.cdRef.detectChanges();
  }

  private getFilterModel(entityId: string): FilterModelWithKeys {
    return {
      UserID: {
        filterType: 'number',
        type: 'equals',
        filter: entityId,
      },
    };
  }
}
